import { z } from 'zod';

/**
 * Схема валидации для входа в систему
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email обязателен для заполнения')
    .email('Введите корректный email адрес'),
  password: z
    .string()
    .min(1, 'Пароль обязателен для заполнения')
    .min(6, 'Пароль должен содержать минимум 6 символов')
});

/**
 * Тип данных формы входа
 */
export type LoginFormData = z.infer<typeof loginSchema>;
